import React from 'react';

const Complete = () => {
    return (
        <div>
            
        </div>
    );
};

export default Complete;